import { FeatureItem } from './FeatureItem/types';

export const FeaturesData: FeatureItem[] = [
  {
    id: 1,
    title: 'Made for You, Feels Like You',
    subTitle:
      'AI turns your ideas into videos with your branding, tone, and even your voice.',
    icon: 'user-01',
  },
  {
    id: 2,
    title: 'Zero Editing, Maximum Presence',
    subTitle:
      'Just 15 minutes every 2 weeks, we handle the rest, from script to social posting.',
    icon: 'clock',
  },
  {
    id: 3,
    title: 'Real Results, Real Engagement',
    subTitle:
      'High-performing content that builds trust and brings leads, automatically.',
    icon: 'line-chart-up-01',
  },
];
